// Auto-generated cornerstone translation for hu.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T14:15:20.744365+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Lómenedzsment app: legjobb választás 2026-ra | EquiSight",
      description: "Hasonlítsa össze a lómenedzsment appokat tulajdonos, istálló és tenyészet számára. Fedezze fel, miért az EquiSight a teljes körű app az Ön lova számára.",
      keywords: [
        "lómenedzsment app",
        "istállómenedzsment app",
        "ló naplóalkalmazás",
        "app több ló kezeléséhez",
        "kanca vemhesség app",
        "lótenyésztés app",
        "legjobb lómenedzsment app",
      ],
    },
    hero: {
      eyebrow: "Választási segédlet · lómenedzsment szoftver",
      breadcrumbLabel: "Lómenedzsment app",
      title: "Lómenedzsment app: a teljes körű választási segédlet tulajdonosoknak, istállóknak és tenyészeteknek.",
      intro: "Nem csupán egy funkciófelsorolás — egy őszinte összehasonlítás, egy választási segédlet és egy áttekintés arról, mit kell tudnia egy lómenedzsment appnak 2026-ban. Egyetlen lóhoz, egy egész istállóhoz vagy a tenyészetéhez.",
      pills: [
        {
          icon: "Users",
          label: "Tulajdonosoknak",
        },
        {
          icon: "Building2",
          label: "Istállóknak",
        },
        {
          icon: "Baby",
          label: "Tenyészeteknek",
        },
        {
          icon: "Share2",
          label: "Csapatoknak",
        },
      ],
      ctas: [
        {
          label: "Kezdd el ingyen 1 lóval",
          href: "#start",
          primary: true,
        },
        {
          label: "Ugrás az összehasonlító táblázathoz",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miért válik egyre fontosabbá egy lómenedzsment app.",
      lead: "A lómenedzsment a valóságban szétszórt: WhatsApp, naptár, Excel, fotók a telefonon, papíralapú útlevél, külön számlák és szóbeli megállapodások. Már egyetlen lónál is kényelmetlen. Több ló, tenyészet vagy megosztott gondozás esetén hiányok, elmulasztott megbeszélések és viták keletkeznek.",
      items: [
        "Hol is volt az az oltási dátum?",
        "Ki fizette ki a patkolót?",
        "Melyik kancát kell ma ellenőrizni?",
        "Elolvasta az edző a múlt heti utasítást?",
        "Tényleg elmentettem azt a fotós dokumentumot?",
        "Még aktuális az istállóban kifüggesztett etetési rend?",
      ],
    },
    what: {
      title: "Mi az a lómenedzsment app?",
      lead: "A lómenedzsment app lényegében egy digitális dosszié lovankénti bontásban. Nincs több szétszórt feljegyzés — egyetlen hely az egészség, az edzés, a takarmányozás, a dokumentumok, a tervezés, az emlékeztetők, a költségek, a fotók, a videók és a megosztott hozzáférés számára. A ló körül mindenki ugyanazt a naprakész információt látja.",
      targetGroupsTitle: "Kinek szól egy lómenedzsment app?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Magántulajdonos",
          body: "Egy ló, egy dosszié — egészség, tervezés és előzmények a zsebedben.",
        },
        {
          icon: "Users",
          title: "Több lovat tartó tulajdonos",
          body: "Különálló profilok, különálló tervezés, közös feladatlista az egész csapatnak.",
        },
        {
          icon: "Building2",
          title: "Panzióistálló és lovarda",
          body: "Tulajdonosi hozzáférés, gondozási utasítások, közös naptár és feladatok.",
        },
        {
          icon: "Baby",
          title: "Tenyészet",
          body: "Kancaciklus, vemhesség, ménadadatok, törzsfák és csikófejlődés.",
        },
        {
          icon: "Target",
          title: "Edzők",
          body: "Lovanként áttekintés, edzések naplózása, célok kitűzése, videók elemzése.",
        },
        {
          icon: "ClipboardList",
          title: "Szakemberek",
          body: "Patkológus, fogorvos, fizioterapeuta vagy állatorvos — ugyanabból a dossziéból dolgoznak.",
        },
      ],
    },
    criteria: {
      title: "Milyen feltételeknek kell megfelelnie egy jó lómenedzsment appnak?",
      lead: "Egy app nem csupán esztétikus — naponta kell gyakorlatiasan működnie. Öt elem, amely nem hiányozhat a 2026-os választásból.",
      items: [
        {
          icon: "FileText",
          title: "Lovankénti lódosszié",
          body: "Adatok, életkor, fajta, útlevélinformációk, tulajdonos, istálló, fotók és dokumentumok — mind egyetlen lóprofilhoz kapcsolva.",
        },
        {
          icon: "Heart",
          title: "Egészség és gondozás",
          body: "Oltások, féregtelenítések, patkolás, fogászat, állatorvos, kezelések, gyógyszerezés és automatikus emlékeztetők a lejárat előtt.",
        },
        {
          icon: "Activity",
          title: "Edzés és haladás",
          body: "Edzések naplózása, feljegyzések, videók, versenyeredmények, célok és haladás diszciplínánként vagy lovankénti bontásban.",
        },
        {
          icon: "Apple",
          title: "Takarmányozás és menedzsment",
          body: "Etetési rendek, kiegészítők, szálastakarmány, súly, testkondíció és az istálló számára szükséges napi rutin.",
        },
        {
          icon: "Share2",
          title: "Megosztás másokkal",
          body: "Hozzáférés a tulajdonosnak, gondozónak, edzőnek, istállótulajdonosnak vagy szakembernek — jogosultságkezeléssel, amely igazodik mindenki szerepéhez.",
        },
        {
          icon: "Calendar",
          title: "Tervezés és emlékeztetők",
          body: "Közös naptár feladatokkal, automatikus emlékeztetőkkel és visszaigazolással, hogy semmi se csússzon ki a rostán.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. egyéb lómenedzsment appok.",
      lead: "A piacon jelenleg a Stalmanager, LogMyHorse, EquineM és Happie Horse a legelterjedtebb versenytársak. Mindegyiknek megvannak az erős pontjai. A leggyakrabban keresett funkciókat egymás mellé állítjuk — őszintén, nyilvánosan elérhető információk alapján.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Ingyenes kezdés",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Több ló",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Egészségdosszié",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Edzés és haladás",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Takarmányozás és kiegészítők",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Tervezés és emlékeztetők",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Lovankénti dokumentumok",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Megosztás csapattal és jogosultságok",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Tenyészetmodul (teljes körű)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kancaciklus",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vemhességtervezés + ultrahangok",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Csikófejlődés",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Szakemberek integrálása",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach elemzések",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Alkalmas tulajdonosnak",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Alkalmas tenyésztőnek",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Alkalmas istállónak/lovardának",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Az összehasonlítás 2026 januárjában nyilvánosan elérhető funkciók alapján készült. A versenytársak szintén jó eszközök; az EquiSight-ot azért fejlesztettük, hogy minden modult egyetlen appban ötvözzön.",
    },
    why: {
      title: "Miért más az EquiSight.",
      lead: "Egy napló csupán rögzít. Az EquiSight egyetlen modern appban ötvözi a lómenedzsmentet, az edzést, a takarmányozást, az egészséget, a versenyeket, a szakembereket és a tenyésztést — és egy lépéssel tovább megy az elemzésekkel.",
      points: [
        {
          icon: "Heart",
          title: "Egyetlen app a ló egész életére",
          body: "A csikótól a sportlóig, a tenyészkancáig vagy a nyugdíjas lóig. A dosszié együtt nő a lovával — semmi sem vész el útközben.",
        },
        {
          icon: "Sparkles",
          title: "Nem csak adatok, hanem minták is",
          body: "Az EquiCoach ötvözi a fejlődést, a visszatérő panaszokat, az edzést és a takarmányozást — így időben észreveszi a jeleket, nem csupán egymástól elszigetelt értesítéseket kap.",
        },
        {
          icon: "Share2",
          title: "Együttműködésre tervezve",
          body: "A tulajdonos, az istállótulajdonos, az edző, a patkológus és más szakemberek ugyanabból a lódossziéból dolgoznak — a szerepükhöz illő jogosultságokkal.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Szakterület · tenyészet",
      title: "Lómenedzsment tenyészeteknek.",
      lead: "Sok versenytárs egyetlen sorban intézi a tenyésztést. Az EquiSight teljes körű tenyészetmodult épített — mert a tenyésztő ritkán az általános app végfelhasználója, mégis a tervezésre a legtöbb másvalakiénél nagyobb szüksége van.",
      items: [
        "Kancaciklus napi nyomon követése",
        "Inszeminálási dátum + ménadadatok",
        "Vemhességellenőrzés ultrahangokkal",
        "Várható ellési dátum + figyelmeztetések",
        "Csikófejlődés havonként",
        "Törzsfák és leszármazás",
        "Feljegyzések kancánként",
        "Az összes vemhes kanca áttekintése",
      ],
      ctaLabel: "Tekintse meg a tenyészetmodult",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Szakterület · istálló és lovarda",
      title: "Lómenedzsment több lóhoz és panzióistállókhoz.",
      lead: "Több lónál a hangsúly kevésbé az adatokon, inkább a kommunikáción van. Minden tulajdonosnak saját igényei, rutinjai, etetési megállapodásai és egészségügyi figyelési pontjai vannak. Minden dolgozónak keresés nélkül hozzá kell tudni ezekhez férni.",
      cards: [
        {
          t: "Lovak tulajdonosonként",
          d: "Minden tulajdonos csak a saját lovát/lovait látja.",
        },
        {
          t: "Gondozási utasítások",
          d: "Lovankénti bontásban látható az istálló számára.",
        },
        {
          t: "Közös naptár",
          d: "Patkológus, állatorvos és versenyek egy nézetben.",
        },
        {
          t: "Feladatlista",
          d: "Alkalmazottakhoz rendelhető, visszaigazolással.",
        },
        {
          t: "Tulajdonosi hozzáférés",
          d: "Az ügyfelek saját appjukban látják lovukat.",
        },
        {
          t: "Vészhelyzeti kapcsolatok",
          d: "Istállóban kialakult stressz esetén mindig megtalálható.",
        },
      ],
      ctaLabel: "Tekintse meg a lovardamodult",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "WhatsApp, Excel és tábla helyett EquiSight.",
      lead: "Konkrétan: így változik meg a mindennapi lómenedzsmentje.",
      rows: [
        {
          before: "WhatsApp-csoportok",
          after: "Strukturált feljegyzések lovankénti bontásban",
        },
        {
          before: "Excel-táblázatok",
          after: "Élő lódosszié előzményekkel",
        },
        {
          before: "Fehértábla az istállóban",
          after: "Közös tervezés a telefonján",
        },
        {
          before: "Szétszórt fotók a kamerán",
          after: "Médiafájlok a lóhoz kapcsolva",
        },
        {
          before: "Szóbeli megállapodások",
          after: "Feladatok és emlékeztetők visszaigazolással",
        },
        {
          before: "Elveszett papíralapú útlevél",
          after: "Dokumentumok mindig kéznél",
        },
      ],
    },
    helper: {
      title: "Melyik lómenedzsment app illik Önhöz?",
      lead: "Válaszolja meg ezt az 5 kérdést, és őszinte ajánlást kap — akkor is, ha az nem mindig az EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Egy lova van vagy több?",
          options: [
            {
              label: "Egy ló",
              score: 1,
            },
            {
              label: "2–5 ló",
              score: 2,
            },
            {
              label: "Több mint 5 ló",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Kezel ügyfelek vagy harmadik felek lovait?",
          options: [
            {
              label: "Nem, csak a saját lovaimat",
              score: 0,
            },
            {
              label: "Néha — családtagok vagy ismerősök számára",
              score: 1,
            },
            {
              label: "Igen, professzionálisan (istálló / lovarda)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Szeretné nyomon követni a tenyésztést és a vemhességet?",
          options: [
            {
              label: "Nem releváns",
              score: 0,
            },
            {
              label: "Néha — alkalmi tenyésztés",
              score: 1,
            },
            {
              label: "Igen, tenyésztő vagyok (vagy leszek)",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Együttműködik edzővel, gondozóval vagy szakemberrel?",
          options: [
            {
              label: "Nem, mindent egyedül csinálok",
              score: 0,
            },
            {
              label: "Igen, 1 személlyel",
              score: 1,
            },
            {
              label: "Igen, több személlyel",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Csak rögzíteni szeretne, vagy elemzéseket is kapni?",
          options: [
            {
              label: "Csak rögzítés",
              score: 1,
            },
            {
              label: "Rögzítés + tervezés",
              score: 2,
            },
            {
              label: "Rögzítés + tervezés + elemzések",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Egy egyszerű napló elegendő — és veled együtt növekszik.",
          body: "Egyetlen lóhoz, megosztott gondozás nélkül, bármelyik lómenedzsment app megfelel. Az EquiSight ingyenesen indul 1 lóval, tehát nincs kockázat. Ha később több lovat, edzőt vagy tenyésztést szeretne hozzáadni, minden funkció már benne van.",
          cta: "Kezdd el ingyen 1 lóval",
        },
        mid: {
          title: "Az EquiSight jól illeszkedik az Ön helyzetéhez.",
          body: "Több igénye is van (több ló, együttműködés vagy elemzések). A legtöbb versenytárs 1-2 modult fed le; az EquiSight egyetlen appban ötvözi ezeket, anélkül hogy különálló eszközöket kellene összekapcsolni.",
          cta: "Fedezze fel, mire képes az EquiSight",
        },
        high: {
          title: "Az EquiSight a legkézenfekvőbb választás.",
          body: "Az Ön helyzete ötvözi a több lovat, az együttműködést, a tenyésztést és/vagy az elemzéseket. Pontosan itt teszi a különbséget az EquiSight — nincsenek szétszórt eszközök, csupán egyetlen lódosszié mindenhez és mindenki számára a ló körül.",
          cta: "Kezdd el ingyen az EquiSight-tal",
        },
      },
    },
    faqTitle: "Gyakran ismételt kérdések a lómenedzsment appokról",
    faq: [
      {
        q: "Mi a legjobb lómenedzsment app?",
        a: "A legjobb lómenedzsment app az Ön helyzetétől függ. Egy egyszerű naplóhoz több app is megfelelő. Ha az egészséget, az edzést, a takarmányozást, a dokumentumokat, a tenyésztést, a tervezést és az együttműködést egyetlen megoldásban szeretné ötvözni, az EquiSight teljes körű megoldásként lett megalkotva, ahol minden egyetlen dossziéban találkozik.",
      },
      {
        q: "Kezelhetek több lovat egyetlen appban?",
        a: "Igen. Egy jó lómenedzsment appnak több lovat kell támogatnia, beleértve a tulajdonosokat, gondozókat, rutinokat, dokumentumokat, megbeszéléseket és emlékeztetőket lovankénti bontásban. Az EquiSight az első kódsor megírásától fogva erre lett tervezve — a lovak önálló dossziék, nem csupán sorok egy listában.",
      },
      {
        q: "Az EquiSight alkalmas tenyészetek számára is?",
        a: "Igen. Az EquiSight tenyészeti funkciókkal konfigurálható, mint például kancaciklus, inszeminálási dátum, vemhességellenőrzés, ménadadatok, törzsfák, várható ellési dátum és csikófejlődés. Pontosan ez az a terület, amelyen a legtöbb versenytárs app alig vagy egyáltalán nem kínál megoldást.",
      },
      {
        q: "Megoszthatom az adatokat az edzőmmel vagy a patkológusommal?",
        a: "Igen. Az EquiSight célja, hogy a releváns információk biztonságosan megoszthatók legyenek a ló körül lévő emberekkel — edző, patkológus, fogorvos, állatorvos, fizioterapeuta, gondozó vagy tulajdonos. Mindenki csak a szerepéhez szükséges jogosultságokat kapja.",
      },
      {
        q: "Miért ne használjuk egyszerűen a WhatsApp-ot vagy az Excelt?",
        a: "A WhatsApp és az Excel addig működik, amíg minden egyszerű marad. Amint több ló, megbeszélések, dokumentumok, kezelések, tulajdonosok vagy tenyésztési adatok is megjelennek, hibalehetővé válik: az információk szétszóródnak, a visszakeresés időt emészt, a szóbeli megállapodások elvesznek. Egy lómenedzsment app lovankénti bontásban gyűjt össze mindent, automatikus emlékeztetőkkel.",
      },
      {
        q: "Mennyibe kerül az EquiSight?",
        a: "1 lóval ingyenesen elkezdheti. Ha több lovat szeretne kezelni, aktiválni a tenyésztési funkciókat, vagy szakembereknek hozzáférést adni, megfizethető Prémium-csomagok állnak rendelkezésre. Az aktuális lehetőségeket az árképzési oldalon tekintheti meg.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Tenyésztési szoftver lóhoz: teljes összehasonlítás 2026",
      description: "Hasonlítsa össze a lótenyésztési szoftvereket: kancaciklus, vemhesség, mén kiválasztása és csikók. Fedezze fel, miért az EquiSight a teljes körű tenyésztési alkalmazás.",
      keywords: [
        "tenyésztési szoftver ló",
        "kancaciklus app",
        "kanca vemhesség app",
        "csikó regisztrációs app",
        "törzskönvy app ló",
        "fedeztetési tervezés ló",
        "mén kiválasztás app",
      ],
    },
    hero: {
      eyebrow: "Döntési segítség · tenyésztési szoftver",
      breadcrumbLabel: "Tenyésztési szoftver",
      title: "Tenyésztési szoftver lovakhoz: a teljes összehasonlítás 2026-ra.",
      intro: "Egy tenyészkanca többet érdemel egy általános lókezelő alkalmazásnál. Hasonlítsa össze a legismertebb eszközök tenyésztési funkcióit, fedezze fel, mire kell igazán figyelni, és tudatosan válasszon olyan szoftvert, amely illik az Ön méneséhez — legyen az nagy vagy kicsi.",
      pills: [
        {
          icon: "Baby",
          label: "Kancaciklus",
        },
        {
          icon: "Heart",
          label: "Vemhességellenőrzés",
        },
        {
          icon: "Sparkles",
          label: "Csikófejlődés",
        },
        {
          icon: "FileText",
          label: "Törzskönyv",
        },
      ],
      ctas: [
        {
          label: "Kezdje el ingyen a tenyésztési modullal",
          href: "#start",
          primary: true,
        },
        {
          label: "Az összehasonlító táblázathoz",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miért nem elegendő egy általános lókezelő app a tenyésztéshez.",
      lead: "A legtöbb lóssport-alkalmazást egy sport- vagy hobbi lóhoz tervezték. A tenyésztésnek egészen más ritmusa van: tüzelés, inszeminálás, vemhességellenőrzés, ultrahang, csikónaptár, törzskönyv és eladás. Egy Excel 2 szezon után elveszíti az átláthatóságát — és több kancánál könnyen elvész az irányítás.",
      items: [
        "Mikor volt Bonita utolsó ciklusa?",
        "Melyik mén van tervezve a következő szezon fedeztetésére?",
        "Be van-e ütemezve a 21 napos ultrahangvizsgálat?",
        "Melyik 2024-es csikókat adták már el?",
        "Hol van a törzskönyvi diagram az anyai nagyapáig?",
        "Hol vannak a DNS-minták és az útlevéladatok?",
      ],
    },
    what: {
      title: "Mi az a lótenyésztési szoftver?",
      lead: "A tenyésztési szoftver kancánként és ménenként specializált dossziékat tartalmaz, kombinálva egy tenyészévi naptárral, vemhességtervezéssel, csikóregisztrációval és törzskönyvi megjelenítéssel. Nem általános lónapló, hanem egy eszköz, amely érti a tenyészciklust: az első tüzeléstől az elválasztásig.",
      targetGroupsTitle: "Milyen típusú tenyésztőknek szól a tenyésztési szoftver?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbi tenyésztő (1-3 kanca)",
          body: "Évente egy-két fedeztetés — áttekintés Excel-akrobatika nélkül.",
        },
        {
          icon: "Building2",
          title: "Kis ménes (4-10 kanca)",
          body: "Tenyészévi terv ciklussal, inszeminálással, vemhességellenőrzéssel és csikódossziéval.",
        },
        {
          icon: "Users",
          title: "Professzionális ménes (10+)",
          body: "Több munkatárs, ménenként kanca kiválasztása, eladás és marketing.",
        },
        {
          icon: "Target",
          title: "Méntulajdonos",
          body: "Rendelési előzmények, spermasztatisztikák és ménenként naptár.",
        },
        {
          icon: "Heart",
          title: "Embrióátültetés",
          body: "Donor + fogadó kanca összekapcsolt dossziéként, ET-naptár.",
        },
        {
          icon: "ClipboardList",
          title: "Törzskönyvi regisztráció",
          body: "DNS-minták, útlevéldokumentumok és törzskönyvi adatok.",
        },
      ],
    },
    criteria: {
      title: "Minek kell megfelelnie a jó tenyésztési szoftvernek?",
      lead: "Nem minden lóalkalmazásban lévő 'tenyésztési funkció' egyforma. Öt kulcsterület, ahol a tenyésztők sok időt veszítenek — és ahol a szoftver valóban számít.",
      items: [
        {
          icon: "Calendar",
          title: "Kancaciklus és tüzelés",
          body: "Napi napló, előrejelző ovuláció, ciklusonkénti előregörgetés és automatikus emlékeztetők.",
        },
        {
          icon: "Heart",
          title: "Inszeminálás és vemhességellenőrzés",
          body: "Fedeztetési és inszeminálási dátumok, ménadatok, 14 napos ultrahang, 21 napos ultrahang, 60 napos ultrahang és nemek meghatározása.",
        },
        {
          icon: "Baby",
          title: "Csikófejlődés",
          body: "Születési adatok, súlydiagram, féregtelenítési terv, elválasztás időpontja, útlevél-regisztráció.",
        },
        {
          icon: "FileText",
          title: "Törzskönyv és iratok",
          body: "Törzskönyvi megjelenítés 4-5 generációig, DNS, útlevélszámok és törzskönyvi státusz.",
        },
        {
          icon: "Target",
          title: "Mén kiválasztása és párosítás",
          body: "Szűrés diszciplína, vérvonalak, ménadatok és korábbi sikerek alapján — nem csak azt, amit a méntulajdonos ajánl.",
        },
        {
          icon: "Share2",
          title: "Együttműködés állatorvossal/inszeminátorral",
          body: "Ultrahangok, minták és státuszok közvetlenül megosztva a kancáival foglalkozó rendeléssel.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs. más tenyésztési szoftverek.",
      lead: "A tenyésztési szoftverek keresési találatai gyakran általános lóalkalmazásokat mutatnak, amelyek egy mondatban említik a tenyésztést. Tisztességesen hasonlítjuk össze, melyik eszköznek van valóban teljes körű tenyésztési folyamata.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Ingyenes kezdés",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Kancaciklus naplózása",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inszeminálás dátuma + mén",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrahangok és vemhességellenőrzés",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Várható csikózási dátum",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Csikódosszié (súly/növekedés)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Törzskönyv 4-5 generációig",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNS- és útlevél-regisztráció",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Mén kiválasztása / párosítás",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embrióátültetés",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Több kanca áttekintése",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Megosztás állatorvossal",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrálva általános dossziéval",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Csikók eladása és marketingje",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Az összehasonlítás a 2026 januárjában nyilvánosan elérhető funkciók alapján készült. Az EquineGenie erős a tenyésztésben, de kevésbé a mobilon és az általános lókezelésben. Az EquiSight mindkettőt ötvözi.",
    },
    why: {
      title: "Miért szolgálja az EquiSight másképp a tenyésztőket.",
      lead: "Sok tenyésztő külön tenyésztési szoftvert és külön lókezelő alkalmazást használ. Az EquiSight mindkettőt ötvözi — anélkül, hogy alkalmazások között kellene váltani vagy kétszer kellene bevinni az adatokat.",
      points: [
        {
          icon: "Heart",
          title: "A tenyészkanca is egyszerűen ló marad",
          body: "A tenyészkancának van egy tenyészéve és egy rendes lódossziéja is — egészség, védőoltások, patkolás. Egy app, minden modul.",
        },
        {
          icon: "Sparkles",
          title: "Előrejelző, nem reaktív",
          body: "Ciklus-előrejelzés, vemhességi mérföldkő-emlékeztetők és csikónaptár — automatikusan az Ön adatai alapján.",
        },
        {
          icon: "Share2",
          title: "Mindenki a tenyésztés körül",
          body: "Inszeminálor, méntulajdonos, állatorvos, vevő, törzskönyv — mindenki megfelelő jogosultsággal fér hozzá.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Diszciplínánként · ciklustól elválasztásig",
      title: "Mit tartalmaz egy tenyésztési dosszié az EquiSightban.",
      lead: "Kancánként teljes tenyésztési dossziét kap, összekapcsolva a szokásos lódossziéval.",
      items: [
        "Napi ciklusnapló előrejelzéssel",
        "Inszeminálás/fedeztetés + ménadatok",
        "Ultrahang-idősor (14/21/60 nap + nem)",
        "Vemhességi mérföldkövek automatikus emlékeztetőkkel",
        "Várható csikózási dátum és előkészítés",
        "Csikódosszié születéstől kezdve",
        "Törzskönyv nagyszülőkig kattintható navigációval",
        "DNS-minta, útlevél, törzskönyvi státusz",
        "Értékesítési folyamat érdeklődőkkel",
        "Mén kiválasztásának előzményei kancánként",
      ],
      ctaLabel: "Tekintse meg a tenyésztési modult",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Az egész ménesnek",
      title: "Áttekintés több kancához és ménhez.",
      lead: "Ha 2-3 kancánál többet tenyészt, az összes ciklus és vemhesség áttekintése kulcsfontosságúvá válik.",
      cards: [
        {
          t: "Ciklus-irányítópult",
          d: "Minden kanca egymás mellett, ciklusállapottal és következő teendővel.",
        },
        {
          t: "Vemhességi folyamat",
          d: "Melyik kancák hol tartanak a vemhességi mérföldkövekben?",
        },
        {
          t: "Csikónaptár",
          d: "Várható születések havonta, az ahhoz igazított logisztikával.",
        },
        {
          t: "Mén portfólió",
          d: "Saját mének vagy állandó inszeminálók rendelési előzményekkel.",
        },
        {
          t: "Törzskönyvi grafikon",
          d: "Ősök elemzése több generáción és vérvonalban.",
        },
        {
          t: "Értékesítési irányítópult",
          d: "Melyik csikókat adták el, foglalták le, vagy érhetők még el.",
        },
      ],
    },
    beforeAfter: {
      title: "Exceltől és naptártól az EquiSight tenyésztési rendszerig.",
      lead: "Konkrétan: így változik meg a tenyészidénye.",
      rows: [
        {
          before: "Ciklus külön feljegyzésben",
          after: "Napi napló előrejelzéssel",
        },
        {
          before: "Ultrahangok WhatsAppon az inszeminálónak",
          after: "Megosztott dosszié fotókkal",
        },
        {
          before: "Vemhességi dátum a naptárban",
          after: "Automatikus mérföldkő-emlékeztetők",
        },
        {
          before: "Csikóútlevél a fiókban",
          after: "Dokumentum csikóprofillal összekapcsolva",
        },
        {
          before: "Törzskönyv papíron",
          after: "Kattintható törzskönyv 4-5 generációig",
        },
        {
          before: "Értékesítési hirdetés Marktplaatson",
          after: "Értékesítési folyamat érdeklődési listával",
        },
      ],
    },
    helper: {
      title: "Melyik tenyésztési szoftver illik Önhöz?",
      lead: "5 kérdés annak megállapításához, hogy teljes körű tenyésztési alkalmazásra van-e szüksége, vagy elegendő egy hobbi eszköz.",
      questions: [
        {
          id: "mares",
          q: "Hány tenyészkancát kezel?",
          options: [
            {
              label: "1 kanca",
              score: 1,
            },
            {
              label: "2-5 kanca",
              score: 2,
            },
            {
              label: "Több mint 5 kanca",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Milyen gyakran tenyészt évente?",
          options: [
            {
              label: "Alkalmanként (néhány évente egyszer)",
              score: 0,
            },
            {
              label: "Évente 1-2 fedeztetés",
              score: 2,
            },
            {
              label: "Évente 3+ fedeztetés",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hogyan inszeminál/fedeztet?",
          options: [
            {
              label: "Természetes fedeztetés",
              score: 1,
            },
            {
              label: "MI friss/hűtött spermával",
              score: 2,
            },
            {
              label: "ET vagy mélyfagyasztás",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Együttműködik állatorvossal/inszeminálóval?",
          options: [
            {
              label: "Egy állandó személy",
              score: 1,
            },
            {
              label: "Több rendelés",
              score: 2,
            },
            {
              label: "Nemzetközi hálózat",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Mit vezet jelenleg?",
          options: [
            {
              label: "Excel vagy papír",
              score: 1,
            },
            {
              label: "Általános lókezelő app",
              score: 2,
            },
            {
              label: "Semmi strukturált",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Egy hobbi eszköz vagy Excel elegendő — de az EquiSight így is hasznos.",
          body: "1 kancánál természetes fedeztetéssel néhány évente egy részletes tenyésztési modul túlzás. Az EquiSight ingyenesen indul, és a tenyésztési modult csak arra az évre aktiválja, amikor fedeztet — frissítési kötelezettség nélkül.",
          cta: "Kezdje el ingyen",
        },
        mid: {
          title: "Az EquiSight tenyésztési modul a megfelelő eszköz.",
          body: "Több kancája vagy több tenyésztési módszere van — arra az általános lóalkalmazások nem épültek. Az EquiSight ötvözi a tenyésztést és az általános gondozást, így nem kell két eszköz között váltogatni.",
          cta: "Tekintse meg a tenyésztési modult",
        },
        high: {
          title: "Az EquiSight az Ön méneséhez készült.",
          body: "Több kanca, ET vagy mélyfagyasztás, nemzetközi csapat — a legtöbb eszköz itt csődöt mond. Az EquiSight ménes szintig skálázódik anélkül, hogy extra licenceket kellene halmozni.",
          cta: "Beszéljen velünk egy Ménes-tervről",
        },
      },
    },
    faqTitle: "Gyakran ismételt kérdések a tenyésztési szoftverről",
    faq: [
      {
        q: "Mi a legjobb tenyésztési szoftver lovakhoz?",
        a: "1 kancánál bonyolult tenyésztési módszer nélkül sok eszköz elegendő. 2-3 kancától, MI vagy ET használatával, illetve állatorvossal és törzskönyvvel való együttműködésnél egy teljes körű tenyésztési modul elengedhetetlenné válik. Az EquiSight ötvözi a tenyésztést az általános lókezeléssel egyetlen alkalmazásban, így nem kell váltogatni.",
      },
      {
        q: "Milyen tenyésztési funkciókra van valóban szükségem?",
        a: "Minimum: ciklusnapló, fedeztetési/inszeminálási adatok, vemhességellenőrzési mérföldkövek és csikódosszié. Opcionális, de hatékony: törzskönyvi megjelenítés, mén-kiválasztási archívum, DNS/útlevél és értékesítési folyamat.",
      },
      {
        q: "Az EquiSight képes előrejelezni egy kanca ciklusát?",
        a: "Igen. Az EquiSight korábbi ciklusadatokat használ az előrejelzett ovuláció megjelenítéséhez, így a megfelelő időpontban tervezi meg az inszeminálást vagy fedeztetést — napi találgatás nélkül.",
      },
      {
        q: "Az EquiSight működik embrióátültetésnél is?",
        a: "Igen. A donor és fogadó kanca összekapcsolt dossziékat kap, ET-naptárral és közös mérföldkövekkel a rendeléssel. Így nem veszíti el az időrendet a bonyolult ET-folyamatban.",
      },
      {
        q: "Importálhatom a meglévő tenyésztési adataimat?",
        a: "A ciklus-, fedeztetési és csikóadatokat kézzel vagy CSV-n keresztül kötegelt formában is be lehet vinni. Aktív tenyésztők esetén segítünk egy egyszeri migrációban, ha több szezon adatai vannak.",
      },
      {
        q: "Hogyan oszthatom meg a dossziét az állatorvosommal vagy az inszeminálóval?",
        a: "Személyenként szerepkörrel kapnak hozzáférést: állatorvos, inszeminálor, méntulajdonos vagy törzskönyv-tisztviselő. Mindenki csak a szerepköréhez szükséges információt látja — nincs szükség teljes hozzáférésre.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Lovaglóiskola szoftver: teljes összehasonlítás és választási útmutató 2026",
      description: "Hasonlítsa össze a lovaglóiskola szoftvereket az órák, lovasok, lovak és adminisztráció kezelésére. Fedezze fel, melyik alkalmazás illik az Ön lovardájához vagy panzióistállójához.",
      keywords: [
        "lovaglóiskola szoftver",
        "istállókezelő alkalmazás",
        "lovarda adminisztrációs szoftver",
        "óratervezés lovarda",
        "panzióistálló szoftver",
        "lovas adminisztráció",
        "ló adminisztráció lovarda",
      ],
    },
    hero: {
      eyebrow: "Választási útmutató · lovaglóiskola szoftver",
      breadcrumbLabel: "Lovaglóiskola szoftver",
      title: "Lovaglóiskola szoftver: a teljes választási útmutató lovardák és panzióistállók számára.",
      intro: "Óratervezés, lovasadminisztráció, lókezelés, számlázás és kommunikáció — egy jó lovaglóiskola szoftver mindezt egy helyen egyesíti. Hasonlítsa össze a legnépszerűbb lehetőségeket, és fedezze fel, melyik illik az Ön istállójához vagy lovardájához.",
      pills: [
        {
          icon: "Calendar",
          label: "Óratervezés",
        },
        {
          icon: "Users",
          label: "Lovasok és ügyfelek",
        },
        {
          icon: "Heart",
          label: "Lógondozás",
        },
        {
          icon: "CreditCard",
          label: "Számlázás",
        },
      ],
      ctas: [
        {
          label: "Demót kérek",
          href: "#start",
          primary: true,
        },
        {
          label: "Összehasonlító táblázathoz",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miért lassítja a lovardát a szétszórt eszközök használata.",
      lead: "A legtöbb lovarda foltozgatott rendszeren működik: óratervezés egy fehér táblán, lovasnyilvántartás Excelben, számlázás egy külön eszközben, lógondozás WhatsApp-on és tulajdonosokkal való kapcsolat személyes üzeneteken keresztül. Egy forgalmas héten dupla foglalások, elfelejtett számlák vagy lovak keletkeznek, amelyek nem tudják, melyik lovas jön hozzájuk.",
      items: [
        "Ki van most óráján Jázminnak?",
        "Melyik lovas nem fizetett még márciusért?",
        "Melyik lovat nem szabad ezen a héten igénybe venni?",
        "Mik a tanulók vészhelyzeti elérhetőségei?",
        "Megkapta már Csillag tulajdonosa a patkoló számláját?",
        "Melyik ló melyik boxban áll?",
      ],
    },
    what: {
      title: "Mi a lovaglóiskola szoftver?",
      lead: "A lovaglóiskola szoftver egyetlen eszközben ötvözi az óratervezést, lovasadminisztrációt, lókezelést, számlázást és kommunikációt. Nincs Excel-akrobatika vagy WhatsApp-spagetti, csak egyetlen hely, ahol a lovarda dolgozik, és a tulajdonosok/lovasok is nyomon követhetnek mindent.",
      targetGroupsTitle: "Milyen típusú vállalkozásnak szól a lovaglóiskola szoftver?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Kis lovarda (1-15 ló)",
          body: "Elsősorban óratervezés és fizetések — fejfájás nélküli adminisztráció.",
        },
        {
          icon: "Users",
          title: "Közepes lovarda (15-40 ló)",
          body: "Több oktató, óratervezés + lóbeosztás + lovasadminisztráció.",
        },
        {
          icon: "ClipboardList",
          title: "Nagy lovas- és panzióistálló (40+)",
          body: "Teljes körű működés számlázással, takarmány- és patkolótervezéssel.",
        },
        {
          icon: "Heart",
          title: "Panzióistálló",
          body: "Tulajdonosi portál, egyéni gondozási utasítások, megosztott naptár.",
        },
        {
          icon: "Target",
          title: "Ugrólovas edzőistálló",
          body: "Versénytervezés, lovankénti edzés, ügyfélkapcsolat.",
        },
        {
          icon: "FileText",
          title: "Lovas vállalkozók",
          body: "Lecke + panzió + klinik + kereskedelem kombinációja — mindenre egyetlen rendszerből.",
        },
      ],
    },
    criteria: {
      title: "Minek kell megfelelnie egy jó lovaglóiskola szoftvernek?",
      lead: "Egy szép alkalmazásnak nincs értelme, ha a munkatársak nem akarnak vele dolgozni. Öt gyakorlati szempont, amely megkülönbözteti a sikert a frusztrációtól.",
      items: [
        {
          icon: "Calendar",
          title: "Többszintű óratervezés",
          body: "Kezdő/haladó, díjlovaglás/ugrás, ló-hozzárendelések és oktatói naptárak — mindenki egymás mellett látható.",
        },
        {
          icon: "Users",
          title: "Lovasadminisztráció",
          body: "Profilok, szint, előfizetés, órabérlet és családi kapcsolatok a fiatal lovasok számára.",
        },
        {
          icon: "Heart",
          title: "Lóbeosztás",
          body: "Melyik lovat hányszor alkalmazzák, pihenési, sérülési és tüzelési időszakokkal.",
        },
        {
          icon: "CreditCard",
          title: "Számlázás és előfizetések",
          body: "Havi előfizetések, órabérletek, egyszeri leckék és automatikus terhelés.",
        },
        {
          icon: "Share2",
          title: "Tulajdonosi portál (panzióistálló)",
          body: "A tulajdonosok saját alkalmazásban látják lovukat — naptár, költségek, patkoló és jegyzetek telefonálás nélkül.",
        },
        {
          icon: "Bell",
          title: "Kommunikáció és emlékeztetők",
          body: "Automatikus óra-emlékeztetők, fizetési értesítések, patkoló-bejelentések — üzengetés nélkül.",
        },
      ],
    },
    comparison: {
      title: "EquiSight és más lovaglóiskola szoftverek összehasonlítása.",
      lead: "Sok lovaglóiskola eszköz erős az óratervezésben vagy a számlázásban, de ritkán a lógondozásban és a tulajdonosi kommunikációban egyszerre. Korrekt módon egymás mellé helyezzük őket.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Ingyenes indulás / próbaidőszak",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Óratervezés",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Több oktató",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lovasadminisztráció",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Lóbeosztás",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lógondozás (oltás/patkoló)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Órabérlet / előfizetés",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online fizetések",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatikus számlázás",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Tulajdonosi portál (panzió)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Patkoló/állatorvos integráció",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS emlékeztetők",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Versénytervezés",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Panzióistállóra alkalmas",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Az összehasonlítás a 2026 januárjában nyilvánosan elérhető funkciók alapján készült. A Stalmanager erős az adminisztrációban, az EquiSight kiemelkedik a panzióistálló-folyamat + lógondozás + tulajdonosi portál terén.",
    },
    why: {
      title: "Miért más az EquiSight lovardák és panzióistállók számára.",
      lead: "Az EquiSight több mint egy óratervező. Mi a lovardát teljes körű működésként látjuk: lovak, emberek, kommunikáció és pénzügyek — mind összefügg egymással.",
      points: [
        {
          icon: "Heart",
          title: "A ló áll a középpontban, nem a naptár",
          body: "Minden lónak saját dossziéja van. Órabeosztás, egészség, patkoló és versenyek egyetlen idővonalon — nem 3 külön eszközben.",
        },
        {
          icon: "Share2",
          title: "Tulajdonosok telefonálás nélkül követnek mindent",
          body: "A panzióistálló tulajdonosainak saját nézetük van: költségek, tervezés, fotók és jegyzetek — heti 5-10 telefonhívást spórol meg.",
        },
        {
          icon: "Bell",
          title: "Automatikus kommunikáció",
          body: "Óra-emlékeztető, oltás-emlékeztető, számla — automatikusan, alkalmazáson/e-mailen/SMS-en keresztül. Nincs több körtesWhatsApp-üzenet.",
        },
      ],
    },
    nicheB: {
      eyebrow: "A panzióistálló számára",
      title: "Mit kap egy panzióistálló az EquiSight-tól.",
      lead: "A panzióistállóknak egyedi kihívásaik vannak, amelyeket a hagyományos lovarda szoftver nem old meg.",
      cards: [
        {
          t: "Tulajdonosi portál",
          d: "Minden tulajdonos csak a saját lov(ak)át, naptárát és költségeit látja.",
        },
        {
          t: "Gondozási utasítások lovanként",
          d: "Takarmány, széna, kiegészítők, takarópokróc-beosztás — az istálló számára látható.",
        },
        {
          t: "Megosztott naptár",
          d: "Patkoló, állatorvos és tulajdonosi látogatások egyetlen nézetben.",
        },
        {
          t: "Felhasználási költségek lovanként",
          d: "Alom, takarmány, erőtakarmány tulajdonosonként továbbszámlázva.",
        },
        {
          t: "Vészhelyzeti kapcsolatok lovanként",
          d: "Tulajdonos + állatorvos + patkoló mindig megtalálható az istálló számára.",
        },
        {
          t: "Legeltetés kezelése",
          d: "Melyik lovak mennek legelőre, pihenőre vagy rehabilitációra?",
        },
      ],
    },
    beforeAfter: {
      title: "Fehér táblától és Exceltől az EquiSight-ig.",
      lead: "Konkrétan: így változik meg egy munkahét a lovardán.",
      rows: [
        {
          before: "Fehér tábla az óratervezéshez",
          after: "Élő tervezés oktatónként",
        },
        {
          before: "Excel lovasokkal és órajegyzetekkel",
          after: "Ügyfél CRM óratörténettel",
        },
        {
          before: "WhatsApp-üzenetek a tulajdonosoknak",
          after: "Tulajdonosi portál a lovukhoz",
        },
        {
          before: "Havi terhelés kézi kezelése",
          after: "Automatikus számlázás + iDEAL",
        },
        {
          before: "Lógondozás papíros hirdetőtáblán",
          after: "Gondozási utasítások lovanként, megosztva",
        },
        {
          before: "Szóbeli megállapodás a patkolóval",
          after: "Patkolótervezés visszaigazolásokkal",
        },
      ],
    },
    helper: {
      title: "Melyik lovaglóiskola szoftver illik Önhöz?",
      lead: "5 kérdés annak megállapítására, hogy az EquiSight a megfelelő platform az Ön lovardájához vagy panzióistállójához.",
      questions: [
        {
          id: "size",
          q: "Hány ló van a vállalkozásában?",
          options: [
            {
              label: "Kevesebb mint 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Több mint 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Mi a fő tevékenysége?",
          options: [
            {
              label: "Elsősorban oktatás",
              score: 1,
            },
            {
              label: "Panzióistálló (lovak panzióban)",
              score: 3,
            },
            {
              label: "Oktatás és panzió kombinációja",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Hány oktatóval dolgozik?",
          options: [
            {
              label: "Csak én magam",
              score: 1,
            },
            {
              label: "2-3 oktató",
              score: 2,
            },
            {
              label: "4 vagy több",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Hogyan kezeli jelenleg a számlázást?",
          options: [
            {
              label: "Kézzel (Word/Excel)",
              score: 3,
            },
            {
              label: "Külön könyvelőprogrammal",
              score: 2,
            },
            {
              label: "Beépítve az óratervezőbe",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Hogyan kommunikál a tulajdonosokkal?",
          options: [
            {
              label: "Személyesen / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Tulajdonosi portál az eszközben",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Egy egyszerű eszköz vagy Excel egyelőre megfelel — de az EquiSight is tud Önnel növekedni.",
          body: "Egy kis oktatóvállalkozásnak egyetlen oktatóval és kevés panzióval egyelőre nem szükséges átfogó csomag. Az EquiSight ingyenesen indul, és a lovardájával együtt növekszik — pár év múlva sem kell fájdalmas migrációval szembenézni.",
          cta: "Ingyenes indulás",
        },
        mid: {
          title: "Az EquiSight logikus fejlesztés az Ön lovardájának.",
          body: "Több oktató, oktatás és panzió kombinációja, vagy különálló számlázás — az EquiSight mindezt egyetlen munkafolyamatba foglalja. Különösen a tulajdonosi portál csökkenti az ad-hoc kommunikációt.",
          cta: "Demót kérek",
        },
        high: {
          title: "Az EquiSight az Ön méretéhez lett tervezve.",
          body: "Panzióistálló + oktatás + több oktató pontosan az a kombináció, amelyben az EquiSight kiemelkedik a hagyományos lovarda eszközökhöz képest. A tulajdonosi portál és a lógondozás-integráció hetente órákat spórol az adminisztrációban és a kommunikációban.",
          cta: "Demo tervezése az Ön istállójához",
        },
      },
    },
    faqTitle: "Gyakran ismételt kérdések a lovaglóiskola szoftverről",
    faq: [
      {
        q: "Mi a legjobb lovaglóiskola szoftver?",
        a: "A tisztán óratervezésre több jó lehetőség is létezik. Amint panzióistállóra, több oktatóra vagy lógondozás-nyomon követésre van szüksége, az EquiSight lesz a teljes megoldás — nincs eszközváltogatás, minden egy helyen.",
      },
      {
        q: "Importálhatom a meglévő ügyfeleket és órákat?",
        a: "Igen. Az ügyféladatok és az órarendek CSV-n keresztül importálhatók. Segítünk az aktív lovardáknak egyszeri migrációval, hogy ne kelljen 200 lovast kézzel bevinni.",
      },
      {
        q: "Működik oktatás nélküli panzióistálló esetén is?",
        a: "Igen. A panzióistálló-mód kikapcsolja az órákat, és a tulajdonosi portálra, takarmányozásra/gondozásra, patkolótervezésre és lovanként továbbszámlázott költségekre összpontosít.",
      },
      {
        q: "A lovasok maguk is bejelentkezhetnek és fizethetnek?",
        a: "Igen. A lovasok saját fiókjukon keresztül láthatják, mely órák elérhetők, bejelentkezhetnek, iDEAL-lal fizethetnek az óradíjért, és órabérleteket vásárolhatnak.",
      },
      {
        q: "Mi a helyzet a ló- és tulajdonosi adatok adatvédelmével?",
        a: "Minden személynek van egy szerepe (tulajdonos, lovas, oktató, alkalmazott). Szerepenként csak azt látja, amire szüksége van. A tulajdonosok csak a saját lovukat, a lovasok csak a saját óráikat látják.",
      },
      {
        q: "Képes az EquiSight csatlakozni a könyvelési szoftveremhez?",
        a: "Igen, az Exact, Moneybird és e-Boekhouden integrációk elérhetők. A számlák ekkor automatikusan átkerülnek a könyvelésbe.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Tréner app ló: összehasonlítás & döntési segédlet edzőknek 2026",
      description: "Hasonlítsd össze a ló- és lovas tréner appokat: edzésnapló, videó, célok, protokollelemzés és ügyfélkezelés. Találd meg a megfelelő eszközt edzőkként.",
      keywords: [
        "tréner app ló",
        "instruktor app",
        "ló edzés app",
        "lovas coaching app",
        "edzésnapló ló",
        "díjlovaglás protokoll elemzés",
        "lótréner szoftver",
      ],
    },
    hero: {
      eyebrow: "Döntési segédlet · tréner szoftver",
      breadcrumbLabel: "Tréner app",
      title: "Tréner app ló: teljes döntési segédlet instruktoroknak és edzőknek.",
      intro: "Egy tréner vagy instruktor kombinációkkal, leckékkel, videókkal, célokkal és versenyekkel egyensúlyoz. Hasonlítsd össze a legjobb tréner appokat lovasterületen, és válaszd azt a platformot, amely 2026-ban is együtt fejlődik a coachingodddal.",
      pills: [
        {
          icon: "Target",
          label: "Célok & tervezés",
        },
        {
          icon: "Video",
          label: "Videóelemzés",
        },
        {
          icon: "TrendingUp",
          label: "Haladás",
        },
        {
          icon: "Users",
          label: "Ügyfelek/kombinációk",
        },
      ],
      ctas: [
        {
          label: "Kezdj el ingyenesen trénerként",
          href: "#start",
          primary: true,
        },
        {
          label: "Az összehasonlító táblázathoz",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miért akadályozza a WhatsApp-coaching a trénereket.",
      lead: "A legtöbb tréner különálló eszközöket használ: WhatsApp a kommunikációhoz, egy füzet a leckékhez, YouTube vagy WeTransfer a videókhoz és Excel a versenyeredményekhez. 5 lovasnál ez működik. 20 lovasnál elvesznek az információk, megfeledkezel a célokról, és elveszíted az egyéni fejlődés feletti kontrollt.",
      items: [
        "Hol van Anouk célja erre a szezonra?",
        "Melyik videót küldtem el tavaly hónapban Bramnak?",
        "Látta Lara az utolsó versenyének protokollelemzését?",
        "Melyik kombináció hány alkalommal edz hetente?",
        "Elolvasta Stardust tulajdonosa az edzési utasításomat?",
        "Mikor adtam utoljára visszajelzést az ingadozó impulzusról?",
      ],
    },
    what: {
      title: "Mi az a tréner app ló és lovas számára?",
      lead: "Egy tréner app ötvözi a coaching-CRM-et (kombinációk, leckék, célok), az edzésnaplót lovanként, a videó-visszajelzést, a versenyezési tervezést és a protokollelemzést. Nincs több különálló WhatsApp/YouTube/Excel, csak egy platform, ahol tréner és lovas együtt dolgozik.",
      targetGroupsTitle: "Milyen típusú trénernek szól ez?",
      targetGroups: [
        {
          icon: "Target",
          title: "Díjlovaglás instruktor",
          body: "Protokoll szkennelése, bírói megjegyzések összekapcsolása edzési célokkal, fejlődés nyomon követése.",
        },
        {
          icon: "Activity",
          title: "Ugratás tréner",
          body: "Pályatervezés, kör-visszajelzés, akadálymagasság kezelése lovanként.",
        },
        {
          icon: "Award",
          title: "Eventing edző",
          body: "Három fegyvernem, három tervezés — mind egymás mellett látható.",
        },
        {
          icon: "TrendingUp",
          title: "Teljesítmény edző (sport)",
          body: "EPI-követés, versenyek, célok — élsportolóknak és csapataiknak.",
        },
        {
          icon: "Users",
          title: "Lovasiskola instruktor",
          body: "Csoportos leckék + egyéni coaching egy appban.",
        },
        {
          icon: "Heart",
          title: "Rekreációs edző",
          body: "Hippoterápia, kezdők, egy lóval rendelkező tulajdonosok.",
        },
      ],
    },
    criteria: {
      title: "Minek kell megfelelnie egy jó tréner appnak?",
      lead: "Az edzés emberi munka, de a megfelelő eszköz 30-50%-kal hatékonyabbá tesz, és a lovasoknak a leckék között is segít fejlődni.",
      items: [
        {
          icon: "Users",
          title: "Kombinációkezelés",
          body: "Ló + lovas mint egy egység, szinttel, célokkal, haladással és előzményekkel.",
        },
        {
          icon: "ClipboardList",
          title: "Leckenotek & célok",
          body: "Leckénként egy note fókuszpontokkal, hosszabb távú célokhoz kapcsolva.",
        },
        {
          icon: "Video",
          title: "Videó-visszajelzés",
          body: "Videó feltöltése, pillanatok megjelölése, szóbeli vagy írásos visszajelzés hozzáadása.",
        },
        {
          icon: "Target",
          title: "Verseny & protokollelemzés",
          body: "Protokollok szkennelése (KNHS/FEI), részenkénti pontszámok, bírói megjegyzések és trendek megtekintése.",
        },
        {
          icon: "Calendar",
          title: "Tervezés & leckekártyák",
          body: "Naptár, fizetések, előfizetések és automatikus emlékeztetők.",
        },
        {
          icon: "Share2",
          title: "Kommunikáció a lovas felé",
          body: "A lovas látja saját oldalát leckékkel, videókkal, célokkal és visszajelzésekkel.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs más tréner appok.",
      lead: "Néhány tréner eszköz a WhatsApp-helyettesítésre koncentrál, mások a protokollelemzésre. Az EquiSight mindkettőt ötvözi egy valódi lódossziéval — így a lovas a leckék között is fejlődik.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Ingyenes kezdés",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinációkezelés",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Leckenotek & visszajelzés",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hosszú távú célok",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Videó feltöltés + visszajelzés",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokoll szkennelés",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Teljesítményindex)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Versenynaptár",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lovas portál",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Leckekártya / előfizetés",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online fizetések",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrált lódosszié",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Patkolókovács/állatorvos látható",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Instruktor ÉS lovas számára",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Több ló lovasnként",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Az összehasonlítás a 2026. januárban nyilvánosan elérhető funkciók alapján készült. Az EquiSight egyedülálló a protokollelemzés + EPI terén, és ezt általános lókezeléssel kombinálja.",
    },
    why: {
      title: "Miért nyújt az EquiSight más tréner élményt.",
      lead: "A legtöbb tréner eszköz ott ér véget, ahol a lecke befejeződik. Az EquiSight folytatja — a lódossziéban, a versenyelemzésben, az állatorvossal és a tulajdonossal való együttműködésben.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokoll szkennelés → edzési cél",
          body: "Szkennelj egy KNHS-protokollt, és azonnal látod, mely részek igényelnek figyelmet. A célok automatikusan előtérbe kerülnek.",
        },
        {
          icon: "Sparkles",
          title: "Az EquiCoach erősíti a szemléletedet",
          body: "Több lecke, verseny és protokoll adatai olyan mintákat tárnak fel, amelyeket fejben nem lehet nyomon követni.",
        },
        {
          icon: "Share2",
          title: "Integrálva a lóval",
          body: "A tréner látja a ló oltási, patkolókovács- és sérüléstörténetét — nem tervez edzést a felépülés közben.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Díjlovagláshoz és ugráshoz",
      title: "Mit tartalmaz egy coaching dosszié az EquiSightban.",
      lead: "Kombinációnként kapsz egy coaching-streamet, amely mindent együtt tart — nem vesznek el többé dolgok a WhatsAppban.",
      items: [
        "Leckenotek fókuszpontokkal munkamenetenként",
        "Hosszú távú célok + mérföldkövek",
        "Videó feltöltés időkód-kommentekkel",
        "KNHS/FEI protokoll szkennelés pontszámokkal",
        "Bírói megjegyzések összekapcsolva az edzéssel",
        "Versenyeredmények és EPI-trend",
        "Ügyfélkapcsolat és lecketörténet",
        "Leckekártya / előfizetés / számlák",
        "Haladási grafikon fegyvernemenként",
        "Megosztott hozzáférés a lótulajdonossal",
      ],
      ctaLabel: "Nézd meg a tréner modult",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "WhatsApp + YouTube helyett EquiSight Trainer.",
      lead: "Konkrétan: így változik meg a coaching munkafolyamatod.",
      rows: [
        {
          before: "WhatsApp lazán elküldött videólinkekkel",
          after: "Videó időkód-visszajelzéssel a dossziéban",
        },
        {
          before: "Füzet lovasnként",
          after: "Coaching napló célokkal + előzményekkel",
        },
        {
          before: "Excel versenypontszámokkal",
          after: "EPI grafikon + protokollelemzés",
        },
        {
          before: "Szóbeli célok",
          after: "Mérföldkövek haladásjelzővel",
        },
        {
          before: "Külön számlázó eszköz",
          after: "Leckék + iDEAL + előfizetés az appban",
        },
        {
          before: "E-mail a tulajdonosnak a haladásról",
          after: "A tulajdonos követi a saját nézetében",
        },
      ],
    },
    helper: {
      title: "Melyik tréner app illik hozzád?",
      lead: "5 kérdés annak megállapításához, hogy egy specializált coaching eszköz értéket adhat-e a gyakorlatodnak.",
      questions: [
        {
          id: "clients",
          q: "Hány aktív kombinációt coacholt?",
          options: [
            {
              label: "Kevesebb mint 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Több mint 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Mi a fő fegyvernemedek?",
          options: [
            {
              label: "Díjlovaglás",
              score: 3,
            },
            {
              label: "Ugrás",
              score: 2,
            },
            {
              label: "Rekreatív / vegyes",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Használsz videót a coachingnál?",
          options: [
            {
              label: "Ritkán",
              score: 0,
            },
            {
              label: "Néha (manuálisan)",
              score: 2,
            },
            {
              label: "Gyakran — rendszeresen",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coacholt versenyzőket?",
          options: [
            {
              label: "Nem, rekreatív",
              score: 0,
            },
            {
              label: "Néha versenyeken",
              score: 2,
            },
            {
              label: "Sokat — a rajtlapok központi szerepet játszanak",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Szeretnéd mérni a coachingodat?",
          options: [
            {
              label: "Nem, az intuíció elegendő",
              score: 0,
            },
            {
              label: "Igen, de nincs rá időm",
              score: 2,
            },
            {
              label: "Igen — adatvezérelt coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Egy egyszerű eszköz vagy akár a WhatsApp is elegendő — egyelőre.",
          body: "Kevesebb mint 5 lovasnál, sok videó vagy verseny nélkül egy coaching app felesleges. Az EquiSight ingyenesen indul, tehát kipróbálhatod, amikor a gyakorlatod növekszik.",
          cta: "Kezdj el ingyenesen",
        },
        mid: {
          title: "Az EquiSight Trainer rendszeresen hatékonyabbá tesz.",
          body: "5-15 kombinációval havonta órákat veszítesz a WhatsAppon és a különálló videókon. Az EquiSight mindent összefog, automatikusan szkenneli a protokollokat, és gondoskodik arról, hogy a lovasok mindig visszanézhessék visszajelzéseiket.",
          cta: "Próbáld ki a Tréner modult",
        },
        high: {
          title: "Az EquiSight a te coaching léptékedre van megalkotva.",
          body: "Sok lovas, videó, versenyek és adatvezérelt coaching: pontosan itt tűnik ki az EquiSight. EPI + protokoll szkennelés + lódosszié olyan előnyt ad, amellyel a versenytársak nem rendelkeznek.",
          cta: "Tervezz be egy demót a coaching gyakorlatodhoz",
        },
      },
    },
    faqTitle: "Gyakran ismételt kérdések a tréner appokról",
    faq: [
      {
        q: "Mi a legjobb tréner app ló és lovas számára?",
        a: "Tisztán kommunikációhoz sok eszköz elegendő (akár a WhatsApp is). Célokhoz, videóelemzéshez, protokoll szkenneléshez, versenykövetéshez és ügyfélkezeléshez egy eszközben az EquiSight a legteljesebb megoldás — főleg azért, mert magát a lovat is nyomon követi, nem csak a kombinációt.",
      },
      {
        q: "Tudja az EquiSight automatikusan olvasni a versenyprotokollokat?",
        a: "Igen. Töltsd fel a KNHS- vagy FEI-protokollt, és az EquiSight kinyeri a részenkénti pontszámokat, a bírói megjegyzéseket, és ezeket összekapcsolja a kombinációval. A trendeket több versenyen keresztül is láthatod.",
      },
      {
        q: "Mi az EPI (Equestrian Performance Index)?",
        a: "Az EPI egy EquiSight-pontszám, amely több versenyeredményt összehasonlítható teljesítményindexszé alakít. Így valódi fejlődést látsz különböző osztályokon és bírákon keresztül.",
      },
      {
        q: "A lovasok maguk is be tudják magukat írni a leckékre és fizetni?",
        a: "Igen. A lovasok bejelentkeznek, látják az elérhető leckeidőpontokat, leckekártyákat vásárolnak és iDEAL-on keresztül fizetnek. Te döntöd el, mit szeretnél kínálni.",
      },
      {
        q: "Működik egy lovasiskola körül dolgozó instruktor számára is?",
        a: "Igen. Szabadúszó trénerként dolgozhatsz saját ügyfelekkel, anélkül hogy lovasiskola fiókot kellene kapcsolnod. Az ügyfelek közvetlenül neked fizetnek.",
      },
      {
        q: "Át tudom vinni a meglévő videóimat és notéimat?",
        a: "A videókat kombinációnként töltheted fel, vagy egy tömeges feltöltési eszközzel. A notékat CSV-n keresztül importálhatod. Aktív trénereket egy egyszeri migrációval segítünk.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Útmutatók és választási segédletek lómenedzsment szoftverekhez | EquiSight",
      description: "Az összes EquiSight útmutató egy helyen: lómenedzsment, tenyésztés, lovarda és edzői szoftver összehasonlítások, valamint választási segédletek 2026-ra.",
      keywords: [
        "lószoftver útmutatók",
        "lómenedzsment választási segédlet",
        "tenyésztési szoftver összehasonlítás",
        "lovarda szoftver útmutató",
        "edzői alkalmazás összehasonlítás",
      ],
    },
    hub: {
      eyebrow: "Hub · útmutatók",
      breadcrumbLabel: "Útmutatók",
      title: "Négy teljes útmutató a megfelelő lószoftver kiválasztásához.",
      intro: "Minden célcsoportnak mélyreható választási segédlet: összehasonlító táblázatok, szempontok, példák és interaktív kvíz. Kattints arra az útmutatóra, amely illik a te helyzetedhez, vagy először böngészd az egyes klaszterek alatti mélyítő cikkeket.",
      stats: {
        guides: "4 választási segédlet",
        articles: "15 mélyítő cikk",
        fair: "Pártatlan összehasonlítás",
      },
      readMoreCta: "Olvasd el a teljes útmutatót",
      relatedHeading: "Mélyítő cikkek",
      articlesCountSingular: "{{count}} mélyítő cikk",
      articlesCountPlural: "{{count}} mélyítő cikk",
      articlesCountAria: "Klaszter cikkeinek száma",
      lastUpdatedPrefix: "Frissítve",
      lastUpdatedAria: "A klaszter utolsó frissítésének dátuma",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Lómenedzsment alkalmazás választási segédlet",
        blurb: "Hasonlítsd össze a legnépszerűbb lómenedzsment alkalmazásokat, és derítsd ki, melyik illik a legjobban a tulajdonoshoz, istállóhoz vagy tenyészethez. Tartalmaz egy pártatlan összehasonlító táblázatot és egy 5 kérdéses választási segédletet.",
        audience: "Tulajdonosoknak, istállótulajdonosoknak és minden lovas embernek, aki átláthatóságot keres.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Tenyésztési szoftver összehasonlítás",
        blurb: "A kancaciklustól a csikófejlődésig: nézd meg, melyik tenyésztési szoftver működik igazán a kancáid számától, tenyésztési módszeredtől és törzskönyvi követelményeidtől függően.",
        audience: "Hobby- és hivatásos tenyésztőknek, méneseknek és ménestulajdonosoknak.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Lovarda szoftver választási segédlet",
        blurb: "Órarendtervezés, lovas adminisztráció, tulajdonosi portál és számlázás — egyetlen eszközben. Hasonlítsd össze a lovardák és penziós istállók lehetőségeit 2026-ban.",
        audience: "Lovardáknak, penziós istállóknak és lovas vállalkozásoknak.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Edzői alkalmazás választási segédlet",
        blurb: "Coaching-CRM, videó-visszajelzés, KNHS-protokoll szkennelés és célok páronként. Melyik edzői alkalmazás illik a te coaching gyakorlatodhoz?",
        audience: "Oktatóknak, edzőknek és coachoknak.",
      },
    ],
    closing: {
      eyebrow: "Miért ezek az útmutatók",
      title: "Pártatlan összehasonlítás, nem csak árak.",
      body1: "Sok „összehasonlító oldal\" valójában rejtett reklám. Útmutatóink a funkciókat, célcsoportot és versenytársakat egymás mellé helyezik, ahogy egy független tudásforrás tenné. Az EquiSight természetesen teljes megoldásként kerül előtérbe, de őszintén olvashatod azt is, hol erősebbek más alkalmazások.",
      body2: "Az egyes útmutatók alatti mélyítő cikkek megválaszolják a döntésből fakadó konkrét kérdéseket: „Mikor az első ultrahang az inszeminálás után\", „Hogyan automatizáljam a lovarda számlázását\", „Hogyan elemezzek egy versenyprotokollt\". Semmi marketingszöveg, csak gyakorlati tudás.",
    },
    hubName: "EquiSight Útmutatók",
  },
  ui: {
    sectionEyebrows: {
      pains: "Miért fájdalmas ez?",
      basics: "Alapok",
      criteria: "Mi teszi jóvá?",
      comparison: "Tisztességes összehasonlítás",
      why: "A különbség",
      beforeAfter: "A széttagoltságtól az áttekinthetőségig",
      helper: "5 kérdés",
    },
    table: {
      feature: "Funkció",
      today: "Ma",
      withEquisight: "Az EquiSight-tal",
    },
    helper: {
      questionLabel: "{{current}}. kérdés a {{total}}-ból",
      answerPrompt: "Válaszolj a maradék {{count}} kérdésre, hogy ajánlást kapj.",
      answerPromptPlural: "Válaszolj a maradék {{count}} kérdésre, hogy ajánlást kapj.",
      resultEyebrow: "Az eredményed",
    },
    targetGroupsFallback: "Kiknek szól ez?",
    faqTitleFallback: "Gyakran ismételt kérdések",
  },
};

export default CORNERSTONES;
